module.exports = __webpack_public_path__ + "static/media/bg3.54b03820.svg";